export default class ErrorLogEntity {    
    ErrorMessage: string
}
